var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiningTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8h16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8l-1 11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8l1 11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8v11"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8v11"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5h10"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5v3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5v3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiningTable);
export default __webpack_public_path__ + "static/media/dining_table.f916007ced80625f41f69e46cbd7f377.svg";
export { ForwardRef as ReactComponent };